import { jsx as r, jsxs as _ } from "react/jsx-runtime";
import S, { useRef as h, useMemo as H } from "react";
import { Error as M } from "../Error/Error.js";
import { Page as A } from "../Page/Page.js";
import { VisuallyHidden as B } from "../VisuallyHidden/VisuallyHidden.js";
import { h as v } from "../../index-B7KtDMz_.mjs";
import { S as D } from "../../errors-YTprc4A2.mjs";
import F from "./Navigation/Navigation.js";
import G from "./Stepper/Stepper.js";
import { useWizardContext as U } from "./context/context.js";
import Y from "./hooks/useTransition.js";
import $ from "./hooks/usePersist.js";
import q from "./hooks/useValidatePreviousSteps.js";
import { ContentWrapper as J, ComponentWrapper as K } from "./styled.js";
function dt({
  isHashEnabled: g = !0,
  isStepperEnabed: x = !1,
  isStepperEnabled: C,
  opacityBetweenLoading: w,
  showHeader: z = !0,
  showFooter: I = !1,
  onWindowClose: N = () => {
  },
  breadCrumbs: P = [],
  storage: W,
  stepsComponents: b,
  headerProps: j,
  children: O,
  scrollOptions: k,
  scrollOnSubmitError: y
}) {
  const i = h(), c = h(null), e = U(), { currentStepId: d, steps: a } = e, E = H(() => {
    const t = Object.values(a ?? {});
    return Array.from(new Set(t.filter((o) => !!o.stepName).map((o) => o.stepName)));
  }, [a]), u = a[d];
  if (!u)
    throw new D(
      "Invalid stepId was provided to Wizard while navigating to a given step"
    );
  const { id: n, title: l, navigation: f, validation: s, stepName: p = "", skipScreenReader: m } = u, R = S.useCallback(() => {
    var t;
    m || (t = c.current) == null || t.focus();
  }, [m]);
  Y(k, R);
  const T = b[n];
  return g && v.useHash(d, (t) => {
    e.dispatch({
      type: "GOTO_STEP",
      stepId: t
    });
  }), v.useBeforeUnload(() => {
    i.current && N(i.current, e.appStates);
  }), O({
    renderStep: (t) => {
      i.current = t, $(t, W);
      const o = {
        form: t,
        wizard: {
          dispatch: e.dispatch
        },
        appStates: e.appStates
      }, V = q({
        validatePreviousSteps: !!(s != null && s.validatePreviousSteps),
        currentStepId: n,
        context: o,
        steps: Object.values(a)
      });
      return /* @__PURE__ */ r(S.Fragment, { children: /* @__PURE__ */ r(
        A,
        {
          headerProps: j,
          title: l,
          loading: e.isPending,
          opacityBetweenLoading: w,
          breadCrumbs: P,
          error: e.error ? /* @__PURE__ */ r(M, { children: e.error.message }) : void 0,
          showHeader: z,
          showFooter: I,
          StaticContent: C ?? x ? /* @__PURE__ */ r(G, { items: E, activeStepName: p }) : void 0,
          children: /* @__PURE__ */ r(J, { children: /* @__PURE__ */ _(K, { children: [
            /* @__PURE__ */ r(B, { as: "a", ref: c, id: "start-step", tabIndex: 0, children: m ? null : `You are on the '${p}' step` }),
            V ? /* @__PURE__ */ r(
              T,
              {
                id: n,
                title: l,
                stepName: p,
                navigation: f,
                validation: s,
                context: o
              },
              n
            ) : null,
            /* @__PURE__ */ r(
              F,
              {
                navigation: f,
                validation: s,
                scrollOnSubmitError: y
              }
            )
          ] }) })
        }
      ) });
    }
  });
}
export {
  dt as default
};
